<template>
  <div class="post-index">
    <div class="img">
      <img @click="img" src="../../assets/sou.png" alt="" />
    </div>
    <van-tabs
      v-model="active"
      title-active-color="#007AFF"
      @click="onClick"
    >
      <van-tab title="音乐">
        <div class="zuida">
          <div class="one">
            <p
              @click="pp(index, item.id)"
              v-for="(item, index) in list"
              :key="index"
              :class="[{ acp: isshpw == index }]"
            >
              {{ item.type }}
            </p>
          </div>
          <div :class="!active ? 'bg_style' : ''">
            <div
              :class="!active ? 'two other_style' : 'two'"
              @click="
                clicks(item.pageView, item.name, item.id, item.content, index)
              "
              v-for="(item, index) in hos"
              :key="index"
            >
              <div class="left">
                <div class="left_image">
                  <div class="listimg">
                    <img :src="item.pageView" alt="" />
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="right_list">
                  <div class="right_top">{{ item.name }}</div>
                  <div class="right_bottom">
                    <p>{{ item.content }}</p>
                    <!-- <p>03:27</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div class="singadd">
          <div class="left">
            <div class="imgas">
              <div class="pinl">
                <img :src="writer" alt="" />
                <div>
                  <p style="color: #333333; font-size: 14px">{{ mold }}</p>
                  <p style="font-size: 12px; color: #999999">{{ photo }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <AudioPlayer
              :audio-list="audioList"
              :before-play="onBeforePlay"
              :before-prev="onPrevPlay"
              :before-next="onNextPlay"
              ref="audio"
              :show-playback-rate="false"
              :show-volume-button="false"
              :show-progress-bar="true"
              theme-color="#007AFF"
            />
          </div>
        </div>
      </van-tab>
      <van-tab title="影视">
        <div class="ys">
          <!-- <div class="one">
            <p
              @click="pp(index, item.id)"
              v-for="(item, index) in listt"
              :key="index"
              :class="[{ acp: isshpw == index }]"
            >
              {{ item.type }}
            </p>
          </div> -->
          <div class="fang">
            <div
              class="fangkuai"
              @click="yings(item.url)"
              v-for="(item, index) in hos"
              :key="index"
            >
              <div class="top">
                <div class="center">
                  <img :src="item.pageView" alt="" />
                </div>
              </div>
              <p style="color: #323332; font-size: 14px">{{ item.name }}</p>
              <p style="color: #999999; font-size: 12px">{{ item.content }}</p>
              <p style="font-size: 14px">
                评分：
                <font style="color: #ff9500; font-size: 14px">{{
                  item.score
                }}</font>
              </p>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="游戏">
        <div class="yxbox">
          <!-- <div class="one">
            <p
              @click="pp(index, item.id)"
              v-for="(item, index) in listtt"
              :key="index"
              :class="[{ acp: isshpw == index }]"
            >
              {{ item.type }}
            </p>
          </div> -->
          <div
            class="list"
            @click="tiao(item.url)"
            v-for="(item, index) in hos"
            :key="index"
          >
            <div class="left">
              <div class="left_item">
                <img :src="item.pageView" alt="" />
              </div>
            </div>
            <div class="right">
              <div class="right-top">{{ item.name }}</div>
              <div class="right-bottom">
                <p>游戏简介</p>
                <p>
                  {{ item.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="button"></div>
  </div>
</template>

<script>
import { homslist, typefastSong } from "../../api/user";

export default {
  data() {
    return {
      audioList: [],
      active: 0,
      isshpw: 0, //命名了
      list: [],
      listt: [],
      listtt: [],
      hos: [],
      a: false,
      photo: "", //音乐专辑
      mold: "", //音乐名称
      writer: "", //音乐图片
      currentPlayIndex: 0, // 当前播放的音频位置索引
      listall: {},
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    //播放中间按钮
    onBeforePlay(next) {
      next();
    },
    //播放左侧按钮
    onPrevPlay(next) {
      next();
      this.photo = this.listall[0].content;
      this.writer = this.listall[0].pageView;
      this.mold = this.listall[0].name;
    },
    //播放右侧按钮
    onNextPlay(next) {
      next();
      this.photo = this.listall[1].content;
      this.writer = this.listall[1].pageView;
      this.mold = this.listall[1].name;
    },
    imgs() {
      this.a = !this.a;
    },
    yings(e) {
      window.open(e);
    },
    clicks(img, name, id, content, index) {
      let playId = index;
      this.$refs.audio.currentPlayIndex = playId;
      this.$nextTick(() => {
        this.$refs.audio.play();
      });
      this.photo = content;
      this.mold = name;
      this.writer = img;
    },
    async getdata() {
      const res = await homslist();

      if (res.rows && res.rows.length) {
        res.rows.map(item => {
          if (item.type === '音乐') this.list = item.children
          if (item.type === '影视') this.listt = item
          if (item.type === '游戏') this.listtt = item
        })
      }

      this.pp(0, this.list[0].id);
    },
    gohomes() {
      this.$router.go(-1);
    },
    tiao(e) {
      window.open(e);
    },
    img() {
      this.miniJump(`/sousuo`)
    },
    async pp(index, id) {
      this.isshpw = index;
      const res = await typefastSong(id);
      this.listall = res.rows;
      this.photo = res.rows[0].content;
      this.mold = res.rows[0].name;
      this.writer = res.rows[0].pageView;
      this.hos = res.rows;
      let add = [];
      res.rows.forEach((item) => {
        add.push([item.url]);
      });
      this.audioList = add;
      this.$nextTick(() => {
        this.$refs.audio.currentPlayIndex = 0;
        this.$refs.audio.currentTime = "";
        this.$refs.audio.pause();
      });
    },
    onClick(name) {
      this.isshpw = 0;
      let id = 4;
      if (name == 0) {
        id = this.list[0].id;
      } else if (name == 1) {
        id = this.listt.id;
      } else {
        id = this.listtt.id;
      }
      this.pp(0, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.post-index {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 50px;
  ::v-deep .van-tabs__wrap {
    position: fixed;
    z-index: 11;
    top: 0;
    left: 0;
    right: 0;
  }
  ::v-deep .van-tabs__content {
    padding-top: 45px;
  }
  .border {
    width: 375px;
    height: 2px;
    background: yellow;
    border-radius: 15px 15px 15px 15px;
    opacity: 1;
  }
  .singadd {
    width: 100%;
    margin: auto;
    display: flex;
    background: #fff;
    position: fixed;
    z-index: 11;
    left: 0;
    right: 0;
    bottom: 50px;
    padding: 10px 0;
    .right {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: relative;
      ::v-deep .audio__progress-wrap {
        margin-top: 0!important;
        top: -53px!important;
        left: calc(-100% - 25px)!important;
        width: calc(200% + 30px)!important;

        .audio__progress-point {
          opacity: 0;
        }
      }
      ::v-deep .audio__time-wrap {
        display: none!important;
      }
      .audio-player {
        width: 90%;
      }
    }
    .left {
      width: 50%;
      height: 100%;
      .imgas {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        .pinl {
          display: flex;
          align-items: center;
          justify-content: space-around;
          p {
            margin-left: 10px;
          }
        }
        img {
          margin-left: 20px;

          width: 40px;
          height: 40px;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
        }
      }
    }
  }

  .yxbox {
    width: 100%;
    background: #f7f7f7;
    .one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 10px 0;
      p {
        width: 5.1875rem;
        height: 2.5rem;
        background: #ffffff;
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        color: #323332;
        font-size: 0.875rem;
        text-align: center;
        line-height: 2.5rem;
      }
      .acp {
        width: 5.1875rem;
        height: 2.5rem;
        background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        text-align: center;
        line-height: 2.5rem;
        color: #ffffff;
        font-size: 0.875rem;
      }
    }
    .list {
      display: flex;

      width: 94%;
      height: 7.5625rem;
      background: #fefffe;
      border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
      margin: auto;
      margin-bottom: 10px;
      .right {
        width: 65%;
        height: 100%;
        .right-bottom {
          width: 100%;
          height: 50%;
          padding: 0.3125rem;
          p {
            color: #999999;
            font-size: 0.75rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        .right-top {
          width: 100%;
          height: 50%;
          color: #323332;
          font-size: 1.125rem;
          font-weight: bold;
          padding: 10px 0.3125rem 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .left {
        width: 35%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .left_item {
          width: 90%;
          height: 90%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .zuida {
    width: 100%;
    background: #f7f7f7;
    margin: auto;
    padding-bottom: 90px;

    .two {
      width: 94%;
      height: 6.25rem;
      display: flex;
      margin: auto;
      background: #ffffff;
      margin-bottom: 10px;
      .right {
        width: 65%;
        height: 100%;
        .right_list {
          width: 100%;
          height: 100%;
          .right_top {
            padding: 0.625rem;
            box-sizing: border-box;
            width: 100%;
            height: 50%;
            color: #323332;
            font-size: 1rem;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .right_bottom {
            width: 100%;
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.625rem 0.625rem;
            box-sizing: border-box;
            p {
              font-size: 0.8125rem;
              color: #999999;
            }
          }
        }
      }
      .left {
        width: 35%;
        height: 100%;
        .left_image {
          width: 100%;
          height: 100%;

          display: flex;
          align-items: center;
          justify-content: center;
          .listimg {
            width: 90%;
            height: 90%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }

    .bg_style {
      background: #fff;
      width: calc(100% - 20px);
      padding: 12px;
      border-radius: 6px;
      margin: 0 auto;
    }
    .other_style {
      width: 100%;
      height: auto;
      margin-bottom: 0;
      padding: 12px 0;
      border-bottom: 1px solid #f7f7f7;
      .left {
        width: auto;
        .left_image {

          .listimg {
            width: 100%;
            height: 100%;
            img {
              border-radius: 6px;
              height: 70px;
              width: 70px;
            }
          }
        }
      }

      .right {
        width: calc(100% - 80px);
        margin-left: 10px;
        height: 70px;
        position: relative;
        padding: 5px 0;

        .right_list {
          .right_top {
            padding: 0;
            height: auto;
          }

          .right_bottom {
            padding: 0;
            height: auto;
            position: absolute;
            bottom: 5px;
          }
        }
      }
    }
    .other_style:first-child {
      padding-top: 0;
    }
    .other_style:last-child {
      padding-bottom: 0;
      border: 0;
    }

    .one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 10px 0px;
      p {
        width: 5.1875rem;
        height: 2.5rem;
        background: #ffffff;
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        color: #323332;
        font-size: 0.875rem;
        text-align: center;
        line-height: 2.5rem;
      }
      .acp {
        width: 5.1875rem;
        height: 2.5rem;
        background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        text-align: center;
        line-height: 2.5rem;
        color: #ffffff;
        font-size: 0.875rem;
      }
    }
  }
  .img {
    width: 40px;
    height: 44px;
    background: #fff;
    position: fixed;
    z-index: 14;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    img {
      z-index: 999;
      position: absolute;
      right: 8px;
      top: 12px;
      width: 18px;
      height: 18px;
    }
  }
  .button {
    width: 100%;
    height: 50px;
    background: #fff;
    position: fixed;
    bottom: 0;
  }
  .ys {
    width: 100%;
    background: #f7f7f7;
    .one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 10px 0;
      p {
        width: 5.1875rem;
        height: 2.5rem;
        background: #ffffff;
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        color: #323332;
        font-size: 0.875rem;
        text-align: center;
        line-height: 2.5rem;
      }
      .acp {
        width: 5.1875rem;
        height: 2.5rem;
        background: linear-gradient(180deg, #4ea3ff 0%, #007aff 100%);
        border-radius: 1.1875rem 1.1875rem 1.1875rem 1.1875rem;
        opacity: 1;
        text-align: center;
        line-height: 2.5rem;
        color: #ffffff;
        font-size: 0.875rem;
      }
    }
    .fang {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 2%;
      .fangkuai {
        width: 46%;
        height: 260px;
        background: #fefffe;
        border-radius: 8px 8px 8px 8px;
        margin: 0px 2% 10px;
        p {
          margin-left: 10px;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .top {
          width: 152px;
          height: 177px;
          border-radius: 6px 6px 6px 6px;
          margin: auto;
          .center {
            width: 90%;
            height: 90%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: red;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .top {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 1.0625rem;
    .incon {
      margin-left: -40px;
    }
  }
}

::v-deep .van-tabs__line {
  background-color: #007aff;
}
::v-deep .audio-player {
  .audio__btn-wrap {
    .audio__play__icon {
      color: #007aff;
    }
  }
  .audio__progress-wrap {
    .audio__progress-point {
      background-color: #007aff;
      box-shadow: 0 0 10px 1px rgba(0, 122, 255, 0.5);
    }
  }
}
</style>